<template lang="pug">
.briq-multilanguage-picker
  .flex.header(v-show="showSecondColumn")
    .ml-header-col.w-full
      span.bold.ml-label.type-bold From: {{ defaultCulture }}
    .ml-header-col.w-full
      span.bold.ml-label.type-bold To:
      BriqMultiselect(
        v-if="cultures"
        :options="cultures"
        v-model="culture"
        display="DisplayName"
        required="required"
        selectLabel=""
        deselectLabel=""
        selectedLabel=""
        bindObject
        :disabled="disabled"
        data-test-id="culture-multiselect"
        )
</template>

<script>
export default {
  name: 'BriqMultilanguagePicker',
  props: {
    defaultCulture: {
      type: String,
      required: true,
    },
    showSecondColumn: Boolean,
    cultures: Array,
    value: Object,
    disabled: Boolean,
  },
  computed: {
    culture: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
}
</script>

<style scoped lang="stylus">
.ml-header-col
  display flex
  align-items center

  .ml-label
    margin-right 10px
</style>

<style lang="stylus">
.briq-multilanguage-picker .briq-multiselect
  margin-bottom 0
</style>
